import { render, staticRenderFns } from "./evaluateSupplier.vue?vue&type=template&id=226d93b6&scoped=true&"
import script from "./evaluateSupplier.vue?vue&type=script&lang=js&"
export * from "./evaluateSupplier.vue?vue&type=script&lang=js&"
import style0 from "./evaluateSupplier.vue?vue&type=style&index=0&id=226d93b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d93b6",
  null
  
)

export default component.exports